// Sổ tiền tệ có version (ADR-002 mục 4, K5): `minorUnitScale` lấy ở đây, UI / AI không tự đoán. Field ghi lại scale lúc tạo
// ⇒ sổ đổi version cũng không làm field cũ đổi nghĩa. Thêm tiền tệ = thêm dòng + tăng version.
export const CURRENCIES_VERSION = 1 as const;

export const CURRENCIES: Readonly<Record<string, number>> = {
  VND: 0,
  JPY: 0,
  KRW: 0,
  USD: 2,
  EUR: 2,
  GBP: 2,
  SGD: 2,
  THB: 2,
  CNY: 2,
  AUD: 2,
  KWD: 3,
};

export const isCurrency = (code: string): boolean => Object.hasOwn(CURRENCIES, code);
export const minorUnitScaleOf = (code: string): number | undefined => (isCurrency(code) ? CURRENCIES[code] : undefined);
